<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || $route.name == 'profile_ahpra'">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>

            <ion-buttons slot="end" v-if="$route.name == 'auth_ahpra'">
                <ion-button class="pill next-pill-button" @click="skip">
                    <span>Skip</span>
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end" v-else>
                <ion-button @click="goNext('userForm')" :disabled="formsData.userForm.disabled">
                    <span>Save</span>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container">
                <div class="auth-header">
                    <div class="auth-heading">
                        <h1>AHPRA Verify</h1>
                        <p class="auth-subtext">Please verify your pharmacist registration with AHPRA!</p>
                    </div>
                    <div class="brand-icon">
                        <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                    </div>
                </div>

                <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                    :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
                    @submit.prevent="goNext('userForm')" @keyup.enter="goNext('userForm')">
                    <el-form-item class="no-scroll" label="AHPRA Registration Number" prop="ahpraNumber"
                        :required="true">
                        <div class="el-input">
                            <input class="el-input__inner" v-imask="formsData.userForm.ahpraNumber.mask"
                                :ref="(el) => (formsData.userForm.ahpraNumber.ref = el)"
                                :value="formsData.userForm.ahpraNumber.value" placeholder="Enter AHPRA registration number"
                                @accept="onFormMaskAccept($event, 'userForm', 'ahpraNumber')"
                                @blur="checkFormValidation('userForm', true, 'ahpraNumber')" />

                        </div>
                    </el-form-item>
                    <el-form-item class="scroll" label="Select Expiration Date" prop="ahpraExpiryDate" :required="true">
                        <el-date-picker popper-class="datepicker_popper drawer-style-ahpra"
                            v-model="formsData.userForm.ahpraExpiryDate.valueFormatted" type="date" class="dob_picker"
                            :placeholder="$filters.systemDateFormat()" :format="$filters.systemDateFormat()" :editable="true"
                            :disabled-date="formsData.userForm.ahpraExpiryDate.disabledDate" @change="dateConvert" />
                    </el-form-item>
                    <el-form-item class="button_submit mb0" v-if="routeName == 'auth_ahpra'">
                        <el-button class="submit" type="blue" @click="goNext('userForm')"
                            :disabled="formsData.userForm.disabled">
                            Continue
                        </el-button>
                    </el-form-item>
                </el-form>
                <div class="background-circles">
                    <div class="circle circle-2"></div>
                    <div class="circle circle-1"></div>
                    <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
                </div>
            </div>
            <!-- <div class="bg-overlay"></div> -->
        </div>
    </div>
</template>

<script>
import { onMounted, inject, watch, getCurrentInstance } from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";

import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    directives: {
        imask: IMaskDirective,
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject("setPageClassGlobal");
        const instance = getCurrentInstance();

        const userData = $store.getters.GET_USER_DATA;
        const ahpra = userData.ahpra;
        const $moment = inject(["$moment"]);
        const routeName = $route.name;
        const reverseAphraDate = (date) => {
            let newDate = date.split("-").reverse();
            return newDate[0] + "-" + newDate[1] + "-" + newDate[2];
        };
        const dateConvert = () => {
            if (formsData.userForm.ahpraExpiryDate.valueFormatted) {
                const result = $moment(formsData.userForm.ahpraExpiryDate.valueFormatted, "YYYY-MM-DD").format(
                    "YYYY-MM-DD")
                console.log("change asdadsa", result);
                formsData.userForm.ahpraExpiryDate.value = result
                console.log("after change asdadsa", formsData.userForm.ahpraExpiryDate.value);
            } else {
                formsData.userForm.ahpraExpiryDate.value = ''
                return null;
            }
            // checkFormValidation("userForm", true);
        };
        const ahpraExpiryDateValue = ahpra
            ? $moment(ahpra, ["YYYY-MM-DD"])
            : new Date(new Date().setFullYear(new Date().getFullYear()));

        const formsDataArray = {
            userForm: {
                ahpraNumber: {
                    value: ahpra.number
                        ? IMask.createMask(formMasks.ahpraNumber).resolve(ahpra.number)
                        : "",
                    mask: formMasks.ahpraNumber,
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "ahpra",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                ahpraExpiryDate: {
                    ref: null,
                    value: ahpra.date
                        ? IMask.createMask(formMasks.ahpraExpiryDate).resolve(
                            reverseAphraDate(ahpra.date)
                        )
                        : "",
                    valueFormatted: ahpraExpiryDateValue,
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    {
                                        rule: "ahpraExpiryDate",
                                    },
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };

        // Watcher to apply mask when date input changes
        watch(
        () => formsData.userForm.ahpraExpiryDate.valueFormatted,
        (newDate) => {
            if (newDate) {
            // Set up mask for 'MM/DD/YYYY' format
            const maskOptions = { mask: `${instance?.appContext.config.globalProperties.$filters.systemDateFormat() }` };
            const masked = IMask.createMask(maskOptions);
            formsData.userForm.ahpraExpiryDate.valueFormatted = masked.resolve(newDate) || '';
            }
        }
        );

        const goBack = async() => {
            if (routeName == "profile_ahpra") {
                $router.push({
                    name: "profile",
                });
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            }
        };

        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    return (async () => {
                        try {
                            if (routeName == "profile_ahpra") {
                                checkFormChanged("userForm", true);

                                if (
                                    formsData[formName].ahpraNumber.fieldChanged ||
                                    formsData[formName].ahpraExpiryDate.fieldChanged
                                ) {
                                    await ElMessageBox.confirm(
                                        `Please note, changes to account details such as Name and AHPRA details will move the status of your account to 'unverified'. Locumate will need to verify your details before you can view and accepts shifts. This process can take up to 24 hours.`,
                                        "Are you sure you want to change this?",
                                        {
                                            distinguishCancelAndClose: true,
                                            showConfirmButton: !formsData[formName].disabled,
                                            confirmButtonText: "Save Changes",
                                            cancelButtonText: "Cancel",
                                            confirmButtonClass: "el-button--green",
                                            cancelButtonClass: "el-button--grey",
                                            showClose: formsData[formName].disabled,
                                        }
                                    );
                                }
                                await $store.dispatch(
                                    "SAVE_USER_DATA",
                                    getFormValues(formName)
                                );
                                copyFormResetValue("userForm", true);
                                $router.push({
                                    name: "profile",
                                });
                            } else {
                                await $store.dispatch(
                                    "SAVE_USER_DATA",
                                    getFormValues(formName)
                                );
                                // if ($router.currentRoute.value.name === "auth_ahpra") {
                                //     $store.commit('addAuthPageBack', 'auth_ahpra');
                                // }
                                $router.push({
                                    name: "auth_address",
                                });
                            }
                        } catch (error) {
                            console.log("error submit!!");
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        onBeforeRouteLeave((to, from, next) => {
            if (routeName == "profile_ahpra") {
                (async () => {
                    try {
                        let leave = await checkFormChanged("userForm");
                        if (leave == "save") {
                            await goNext("userForm");
                        } else if (!leave) {
                            next(false);
                        } else {
                            next();
                        }
                    } catch (error) {
                        next(false);
                        console.log(error);
                    }
                })();
            } else {
                next();
            }
        });

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    $router.push({
                        name: "auth_address",
                    });
                } catch (error) {
                    console.log(error);
                }
            })();
        };

        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            if (routeName == "profile_ahpra") {
                checkFormValidation("userForm", true);
            } else {
                checkFormValidation("userForm", false);
            }
        });

        const {
            ["onFormMaskAccept"]: onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            copyFormResetValue,
            checkFormChanged,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            onFormMaskAccept,
            checkFormValidation,
            goBack,
            goNext,
            skip,
            routeName,
            dateConvert,
            instance

        };
    },
};
</script>
